import { Alert, Snackbar } from '@mui/material';
import React, { useEffect, useState } from 'react';

const StatusAlert = ({ status }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (status?.type) {
      setOpen(true);

      const timer = setTimeout(() => {
        setOpen(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [status]);

  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={() => setOpen(false)}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
      {status?.message && (
        <Alert
          onClose={() => setOpen(false)}
          severity={status.type}
          variant="filled">
          {status.message}
        </Alert>
      )}
    </Snackbar>
  );
};

export default StatusAlert;
